import type { EntityData } from '@adornis/baseql/entities/types.js';
import { FileInput } from '@adornis/file-utils/client/file-input.js';
import type { FunctionalForm } from '@adornis/forms/use-form.js';
import { stateful } from '@adornis/functional-lit/stateful.js';
import { FormGridEntry } from '@martinus/styles/client/FormGridEntry.js';
import { html, nothing } from 'lit';
import type { Person } from '../../../entities/person.js';

export const EmployeeSectionPersonalakteForm = stateful((props: { form: FunctionalForm<EntityData<Person>> }) => {
  if (!props.form.document) return nothing;

  return html`
    <div class="form-grid">
      <p class="col-span-full mb-6">Nachstehende Dokumente stellen die vollständige Personalakte dar:</p>
      ${FormGridEntry({
        label: 'Allgemeine Unterlagen',
        render: FileInput({
          ...props.form.field('mitarbeiterDaten', 'anPersonalakte', 'unterlagenID'),
          placeholder: 'Keine Unterlagen hinterlegt',
          placeholderMode: 'hide',
        }),
      })}
      ${FormGridEntry({
        label: 'Personalbogen',
        render: FileInput({
          ...props.form.field('mitarbeiterDaten', 'anPersonalakte', 'personalbogenID'),
          placeholder: 'Kein Personalbogen hinterlegt',
          placeholderMode: 'hide',
        }),
      })}
      ${FormGridEntry({
        label: 'Verträge',
        labelSubtext: 'Gedruckte und unterschriebene Verträge',
        render: FileInput({
          ...props.form.field('mitarbeiterDaten', 'anPersonalakte', 'vertraegeIDs'),

          multi: true,
        }),
      })}
      ${FormGridEntry({
        label: 'Erklärungen',
        render: FileInput({
          ...props.form.field('mitarbeiterDaten', 'anPersonalakte', 'erklaerungenIDs'),

          multi: true,
        }),
      })}
      ${FormGridEntry({
        label: 'ADDs',
        render: FileInput({
          ...props.form.field('mitarbeiterDaten', 'anPersonalakte', 'addIDs'),

          multi: true,
        }),
      })}
    </div>
  `;
});
